import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWave: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconWave"><Path d="M2.75 12H4C5.65685 12 7 10.6569 7 9V6.25C7 4.86929 8.11929 3.75 9.5 3.75C10.8807 3.75 12 4.86929 12 6.25V17.75C12 19.1307 13.1193 20.25 14.5 20.25C15.8807 20.25 17 19.1307 17 17.75V14.5C17 12.8431 18.3431 11.5 20 11.5H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconWave;
